import React from 'react';
import { Box } from '@mui/material';
import PageHeader from '../components/PageHeader';
import TokenManagement from '../components/TokenManagement';
import { useAuth } from '../context/AuthContext';
import { Alert } from '@mui/material';

const TokenManagementPage: React.FC = () => {
  const { user } = useAuth();

  if (user?.role !== 'superuser') {
    return <Alert severity="error">You are not authorized to view this page.</Alert>;
  }

  return (
    <Box sx={{ p: 3 }}>
      <PageHeader
        title="Token Management"
        subtitle="Create and manage activation tokens for school subscriptions"
      />
      <TokenManagement />
    </Box>
  );
};

export default TokenManagementPage; 